import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLineChart1"><Path d="M9.5 10.5V16.5M14.5 4.5V16.5M19.5 12.5V16.5M3.5 3.5V20.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLineChart1;
